/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

const defaultConfig = {
  cleanUpTextKeys: true,
  cleanUpEmptyKeys: true,
  cleanUpPrefixKeys: true,
};

export default function cleanUpResponse(inputObj, config = defaultConfig, currPath) {
  for (const [key, value] of Object.entries(inputObj)) {
    const thisPath = currPath ? `${currPath}.${key}` : key;
    // check if this path is in the excluded keys list. If so, return early.
    if (_.isArray(config?.excludedKeys) && config.excludedTextKeys.indexOf(thisPath) >= 0) {
      return;
    }
    if (_.isPlainObject(value)) {
      if (config?.cleanUpPrefixKeys && _.has(value, '__prefix')) {
        delete value.__prefix;
        if (_.isEmpty(value)) {
          inputObj[key] = null;
        }
      }
      if (value.$null === 'true' || value['$xsi:nil'] === 'true' || value.$nil === 'true') {
        inputObj[key] = null;
      } else if (config?.cleanUpTextKeys && _.has(value, '__text')) {
        inputObj[key] = value.__text;
      } else if (config?.cleanUpEmptyKeys && _.every(value, (v, k) => _.isString(k) && _.includes(k, '$'))) {
        inputObj[key] = null;
      } else {
        cleanUpResponse(value, config, thisPath);
      }
    } else if (_.isArray(value)) {
      // value is an array here
      for (const item of value) {
        cleanUpResponse(item, config, thisPath);
      }
    }
  }
}
